/**
 * Paid, but the checkout page was gone before Razorpay's success callback
 * (2026-09-24, ORD-2026-000007: the browser reloaded to the dashboard mid card
 * payment, so nothing ever told the backend and the user saw only a draft).
 *
 * On load, asks the backend to confirm the user's pending payments with
 * Razorpay (`POST /purchases/confirm-pending`). Whatever it completes is
 * returned for a banner, and broadcast so open pages (the Invitations list)
 * refresh. Best-effort: a failure is silent, and the backend sweep still
 * recovers the payment within minutes.
 */
import { useCallback, useEffect, useState } from 'react';
import { confirmPendingPayments, type ConfirmedPurchase } from './api';

export const PAYMENTS_CONFIRMED_EVENT = 'invitecloud:payments-confirmed';

export function usePendingPaymentConfirmation() {
  const [confirmed, setConfirmed] = useState<ConfirmedPurchase[]>([]);

  useEffect(() => {
    let cancelled = false;
    confirmPendingPayments()
      .then(({ confirmed: found }) => {
        if (cancelled || found.length === 0) return;
        setConfirmed(found);
        window.dispatchEvent(new CustomEvent(PAYMENTS_CONFIRMED_EVENT, { detail: found }));
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  const dismiss = useCallback(() => setConfirmed([]), []);
  return { confirmed, dismiss };
}
